import React, { useState } from 'react';
import {
  Box,
  Button,
  Typography,
  TextField,
  InputAdornment
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import axiosInstance from '../config/axios';
import AddDocumentDialog from '../components/documents/AddDocumentDialog';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { IND_ENABLED } from '../config/env';
//import PeopleIcon from '@mui/icons-material/People';
// Removed: import { useNavigate } from 'react-router-dom';

// Unified document list for use in document map, flowchart, etc.
export const unifiedDocumentList = [
  { id: 'subject-asset', name: 'Subject Asset Form', icon: <AssignmentIcon /> },
  //{ id: 'ib', name: 'IB', icon: <AssignmentIcon /> },
  //{ id: 'committees', name: 'Committees: DSMB, IDMC, ILDAC, Endpoint Adjudication, BICR, Steering Committee', icon: <PeopleIcon /> },
  { id: 'Stering Committee charter', name: 'Stering Committee charter', icon: <AssignmentIcon /> },
  { id: 'Adjudication charter', name: 'Adjudication charter', icon: <AssignmentIcon /> },
  { id: 'DSMB', name: 'DSMB', icon: <AssignmentIcon /> },
  { id: 'IDMC', name: 'IDMC', icon: <AssignmentIcon /> },
  { id: 'ae-sae', name: 'AE/SAE Reporting Plan', icon: <AssignmentIcon /> },
  //{ id: 'impd', name: 'IMPD', icon: <AssignmentIcon /> },
  { id: 'subject-reimbursement', name: 'Subject Reimbursement Policy', icon: <AssignmentIcon /> },
  { id: 'randomization', name: 'Randomization and Data blinding Plan', icon: <AssignmentIcon /> },
  { id: 'sap', name: 'SAP', icon: <AssignmentIcon /> },
  //{ id: 'safety-management', name: 'Safety Management Plan', icon: <AssignmentIcon /> },
  { id: 'patient-diary', name: 'Patient Diary and Log', icon: <AssignmentIcon /> },
  //{ id: 'data-transfer', name: 'Data Transfer Agreements', icon: <AssignmentIcon /> },
  //{ id: 'site-contract', name: 'Site Contract', icon: <AssignmentIcon /> },
  //{ id: 'site-feasibility', name: 'Study Site Level feasibility', icon: <AssignmentIcon /> },
  { id: 'protocol-deviation', name: 'Protocol Deviation monitoring Plan', icon: <AssignmentIcon /> },
  //{ id: 'sdv-plan', name: 'SDV Plan', icon: <AssignmentIcon /> },
  { id: 'ip-management', name: 'IP Management', icon: <AssignmentIcon /> },
  { id: 'site-training', name: 'Site Training Material', icon: <AssignmentIcon /> },
  { id: 'site-monitoring', name: 'Site Monitoring Plan', icon: <AssignmentIcon /> },
  //{ id: 'site-audit', name: 'Site Audit Plan', icon: <AssignmentIcon /> },
  { id: 'recruitment', name: 'Recruitment Strategy', icon: <AssignmentIcon /> },
  { id: 'retention-compliance', name: 'Retention and Compliance Plan', icon: <AssignmentIcon /> },
  //{ id: 'central-lab', name: 'Central Laboratory Manual', icon: <AssignmentIcon /> },
  { id: 'cultural-linguistic', name: 'Cultural and Linguistic adaption guidelines', icon: <AssignmentIcon /> },
  //{ id: 'trial-monitoring', name: 'Trial Monitoring Plan including RBM', icon: <AssignmentIcon /> },
  { id: 'translational-analysis', name: 'Translational Analysis Plan', icon: <AssignmentIcon /> },
  { id: 'imaging-charter', name: 'Imaging Charter', icon: <AssignmentIcon /> },
  { id: 'bioanalytical', name: 'Bioanalytical Sample collection and Processing manual', icon: <AssignmentIcon /> },
  { id: 'pk-pd', name: 'PK/PD Analysis Plan', icon: <AssignmentIcon /> },
  //{ id: 'lnr-management', name: 'LNR Management Plan', icon: <AssignmentIcon /> },
  // Hardcoded/sample documents from documentHierarchy and mock data
  //{ id: 'protocol-v1', name: 'Protocol v1.0', icon: <AssignmentIcon /> },
  //{ id: 'protocol-v2', name: 'Protocol v2.0', icon: <AssignmentIcon /> },
  //{ id: 'icf-template', name: 'ICF Template', icon: <AssignmentIcon /> },
  //{ id: 'irb-approval', name: 'IRB Approval', icon: <AssignmentIcon /> },
  //{ id: 'fda-form-1572', name: 'FDA Form 1572', icon: <AssignmentIcon /> },
  //{ id: 'study-protocol', name: 'Study Protocol', icon: <AssignmentIcon /> },
  { id: 'Protocol', name: 'Protocol', icon: <AssignmentIcon /> },
  { id: 'ICF', name: 'ICF', icon: <AssignmentIcon /> },
  ...(IND_ENABLED ? [{ id: 'IND', name: 'IND', icon: <AssignmentIcon /> }] : []),
];

const DocumentMap = ({ projectId }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  // Removed: const navigate = useNavigate();

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleAddDocument = () => {
    setAddDialogOpen(true);
    setError('');
  };

  const handleDialogClose = () => {
    setAddDialogOpen(false);
    setError('');
  };

  const handleDialogSubmit = async (name) => {
    setSubmitting(true);
    setError('');
    try {
      await axiosInstance.post('/documents/create-name-only', {
        title: name,
        projectId
      });
      setAddDialogOpen(false);
      // Optionally: refresh document map here
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to add document');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h5" gutterBottom sx={{ mb: 0 }}>
          Document Map
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <TextField
            variant="outlined"
            size="small"
            placeholder="Search documents..."
            value={searchTerm}
            onChange={handleSearch}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleAddDocument}
          >
            + Add Document
          </Button>
        </Box>
      </Box>
      <AddDocumentDialog
        open={addDialogOpen}
        onClose={handleDialogClose}
        onSubmit={handleDialogSubmit}
        loading={submitting}
        error={error}
      />
    </Box>
  );
};

export default DocumentMap; 